import { Box, CloseButton, Divider, Group, LoadingOverlay, Title } from "@mantine/core"
import { ReactNode } from "react"
import classes from "./order-action-card.module.css"

type Props = Readonly<{
  title: ReactNode
  onClose: () => void
  /** Footer buttons, right aligned: «Болих» first, the one primary action last. */
  footer: ReactNode
  loading?: boolean
  children: ReactNode
}>

/** Shared body of the order action dialogs (Ord_SalesModals): title + close, content, one footer. */
export function OrderActionCard({ title, onClose, footer, loading = false, children }: Props) {
  return (
    <Box pos="relative">
      <LoadingOverlay visible={loading} />
      <Group justify="space-between" align="center" wrap="nowrap" className={classes.header}>
        <Title order={3} className={classes.title}>{title}</Title>
        <CloseButton aria-label="close" onClick={onClose} />
      </Group>
      <Box className={classes.body}>{children}</Box>
      <Divider />
      <Group justify="flex-end" gap="sm" className={classes.footer}>
        {footer}
      </Group>
    </Box>
  )
}
